import React, { useRef } from "react";
import { Tooltip } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import PropTypes from "prop-types";

const useStyles = makeStyles(theme => ({
  arrow: {
    color: "#fff"
  },
  tooltip: {
    boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.25)",
    position: "relative",
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(2, 3),
    display: "flex",
    flexDirection: "column",
    maxWidth: 350,
    color: theme.palette.text.primary,
    ...theme.typography.body2
  },
  tooltipPlacementTop: {
    margin: ({ margin }) => margin
  },
  tooltipPlacementBottom: {
    margin: ({ margin }) => margin
  }
}));

export default function useTooltipStyles({
  interactive,
  placement,
  title,
  areaRef,
  PopperProps,
  hideArrow,
  showTooltipOnMouseEntryPoint,
  margin,
  ...props
}) {
  const { tooltipTopShadow, ...classes } = useStyles({ margin });

  const positionRef = useRef({
    x: 0,
    y: 0
  });

  const popperRef = useRef(null);

  const handleMouseEnter = showTooltipOnMouseEntryPoint
    ? event => {
        positionRef.current = { x: event.clientX, y: event.clientY };

        if (popperRef.current != null) {
          popperRef.current.update();
        }
      }
    : undefined;
  return (
    <Tooltip
      arrow={!hideArrow}
      disableInteractive={!interactive}
      placement={placement}
      classes={classes}
      onMouseEnter={handleMouseEnter}
      PopperProps={{
        popperRef,
        ...(showTooltipOnMouseEntryPoint && {
          anchorEl: {
            getBoundingClientRect: () => {
              return new DOMRect(
                positionRef.current.x,
                areaRef.current.getBoundingClientRect().y,
                0,
                0
              );
            }
          }
        }),
        ...PopperProps
      }}
      {...props}
      title={!title ? "" : <React.Fragment>{title}</React.Fragment>}
    />
  );
}

useTooltipStyles.propTypes = {
  // If true, the tooltip will show up where the user's mouse entered its child. This should be true
  // whenever we show a tooltip on large elements, like a table row for example
  showTooltipOnMouseEntryPoint: PropTypes.bool
};

useTooltipStyles.defaultProps = {
  interactive: true,
  placement: "top",
  title: "",
  hideArrow: false,
  showTooltipOnMouseEntryPoint: false,
  margin: "12px 0"
};
